import { ThemeProvider } from '@icims-design-system/mui-core';
import { CircularProgress, Container, CssBaseline } from '@mui/material';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router';

import {
	useExternalSubmissionThemeState,
	useExternalSubmissionThemeUpdater,
} from '../context/ExternalSubmissionThemeContext';
import AlertMessage from './AlertMessage';
import FeedbackForm from './FeedbackForm';
import TopMenu from './TopMenu';
import { initializeTeams } from './teamsUtil';

const ExternalSubmission = () => {
	const [searchParams] = useSearchParams();

	const { theme } = useExternalSubmissionThemeState();
	const { setTheme } = useExternalSubmissionThemeUpdater();

	useEffect(() => {
		// If the SPA is being rendered in Teams, initialize the Teams SDK to retrieve the theme
		if (searchParams.get('teams') === 'true') {
			initializeTeams(setTheme);
		} else {
			// If the SPA is not being rendered in Teams, set the theme to 'light'
			setTheme('light');
		}
	}, [searchParams, setTheme]);

	if (theme === null) {
		return <CircularProgress />;
	}

	return (
		<ThemeProvider variant={theme}>
			<CssBaseline />
			<Container maxWidth="md" data-testid="feedback-container">
				<TopMenu />
				<AlertMessage />
				<FeedbackForm />
			</Container>
		</ThemeProvider>
	);
};

export default ExternalSubmission;
